export default Object.freeze({
	Add: 'ADD_NEW_USER',
	UpdateUser: 'UPDATE_SINGLE_USER',
	UpdateMultiUser: 'UPDATE_MULTI_USER',
});
